import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

const getReleaseNumberUrl = '/organizations/getReleaseNumber.html';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  appVersion: string;

  constructor(private http: HttpClient) {}

  getReleaseNumber(): Observable<string> {
    return this.http
      .get(getReleaseNumberUrl, {
        responseType: 'text',
        headers: {
          Accept: 'text/plain, */*'
        }
      })
      .pipe(tap((appVersion) => (this.appVersion = appVersion)));
  }
}
